import _, { startCase } from 'lodash';

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  PENDING_CLOSURE = 'PENDING_CLOSURE',
  FROZEN = 'FROZEN',
  BLOCKED = 'BLOCKED',
  CLOSED = 'CLOSED',
}

export enum VerificationStatus {
  NOT_PROVIDED = 'NOT_PROVIDED',
  REQUESTED = 'REQUESTED',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED',
}

const LABELS: Record<string, string> = {
  uuid: 'User ID',
  qbid: 'QB ID',
  dob: 'Date of Birth',
  isKycVerified: 'KYC Status',
};

export const getLabel = (key: string) => {
  if (key in LABELS) return LABELS[key];
  return startCase(key);
};

export interface Proof {
  page1: string | null;
  page2: string | null;
  page3: string | null;
}

export interface SkinningCustomer {
  id: string;
  qbId: string;
  firstName: string;
  lastName: string;
  email: string;
  dob: Date;
  country: string;
  skin: string;
  phoneNo: string;
  isVerified: boolean;
  ts: Date;
  lastUpdateTs: Date;
  addressProof: Proof;
  idProof: Proof;
}

export const hasProofImages = (customer: SkinningCustomer): boolean => {
  return (
    (!_.isEmpty(customer.addressProof.page1) ||
      !_.isEmpty(customer.addressProof.page2) ||
      !_.isEmpty(customer.addressProof.page3)) &&
    (!_.isEmpty(customer.idProof.page1) ||
      !_.isEmpty(customer.idProof.page2) ||
      !_.isEmpty(customer.idProof.page3))
  );
};
